// These should be removed once we transition to webpack as it is throwing warnings due to having no import/exports
/* eslint-disable react/jsx-no-undef */

import {
  useState,
  Fragment,
  ChangeEvent,
  MouseEvent
} from 'react';
import SegmentedRadioButtons from 'src/react_components/form-helpers/segmented-radio-buttons';
import Citation from 'annotator/citation';
import SvgIcon from 'src/react_components/svg-icon';
import { CiteStatus } from 'annotator/annotator-types';

type CitationPaneProps = {
  sources: number[],
  annotationId: number | null,
  citeStatus: CiteStatus,
  saveCiteStatus: (status: CiteStatus) => void,
  isEditable: boolean,
  contextWidth: null | number
}

const CitationPane = ({
  sources, annotationId, citeStatus, saveCiteStatus, isEditable, contextWidth
}: CitationPaneProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const toggleDescription = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    setExpanded(!expanded);
  };

  const handleCiteStatusChange =
    (event: ChangeEvent<HTMLInputElement>) => saveCiteStatus(event.target.value as CiteStatus);

  const matches = sources && sources.length;

  const displayPanel = matches > 0;
  const matchDescription = `${matches} source${matches === 1 ? '' : 's'} found`;

  const citingSegments = [
    { value: 'cited', text: 'Cited', id: 'cited_radio' },
    { value: 'not_cited', text: 'Not Cited', id: 'not_cited_radio' }
  ];

  return (
    <Fragment>
      {displayPanel && (
        <Fragment>
          <div className="panel-body panel-sources">
            <div className="description-wrapper">
              <button type="button" className="btn-plaintext description" onClick={toggleDescription}>
                <SvgIcon
                  className="icon-info"
                  icon={expanded ? 'expand_more' : 'navigate_next'}
                />
                {matchDescription}
                <span className="sr-only">{expanded ? ' Click to hide.' : ' Click to show.'}</span>
              </button>
            </div>

            {expanded && sources.map((source) => (
              <Citation source={source} key={source} />
            ))}
          </div>
          {isEditable && (
            <SegmentedRadioButtons
              segments={citingSegments}
              name={annotationId?.toString() || ''}
              onChange={handleCiteStatusChange}
              value={citeStatus}
              vertical={!!contextWidth && contextWidth < 185}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default CitationPane;
